import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.get(`${API}/unsubscribe/${token}`)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-ivory flex flex-col items-center justify-center px-6 py-20">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Logo / Brand */}
        <p className="font-lora text-[10px] tracking-[0.3em] uppercase text-gold">
          De Nicola Consulting Co.
        </p>
        <div className="w-8 h-px bg-gold mx-auto" />

        {status === "loading" && (
          <div>
            <div className="w-6 h-6 border-2 border-navy/20 border-t-navy rounded-full animate-spin mx-auto mb-4" />
            <p className="font-serif text-navy/60 text-sm">Processing your request...</p>
          </div>
        )}

        {status === "success" && (
          <div data-testid="unsubscribe-success">
            <h1 className="font-lora text-navy text-2xl font-normal mb-4">
              You've been unsubscribed.
            </h1>
            <p className="font-serif text-navy/60 text-base leading-relaxed mb-6">
              You will no longer receive marketing emails from De Nicola Consulting Co.
              Your information remains in our records, and any existing bookings or
              agreements are unaffected.
            </p>
            <p className="font-serif text-navy/40 text-sm leading-relaxed mb-8">
              If you change your mind, you can always download the Career Roadmap again
              to re-subscribe to our advisory updates.
            </p>
            <Link
              to="/"
              className="inline-block bg-navy text-ivory px-8 py-3 text-xs tracking-widest uppercase hover:bg-navy/90 transition-all"
              data-testid="unsubscribe-home-link"
            >
              Return to Home
            </Link>
          </div>
        )}

        {status === "error" && (
          <div data-testid="unsubscribe-error">
            <h1 className="font-lora text-navy text-2xl font-normal mb-4">
              Something went wrong.
            </h1>
            <p className="font-serif text-navy/60 text-base leading-relaxed mb-8">
              This unsubscribe link may be invalid or already used.
              If you would like to be removed from our list, please email us directly at{" "}
              <a
                href="mailto:julia@denicolaconsulting.com"
                className="text-navy underline underline-offset-2"
              >
                julia@denicolaconsulting.com
              </a>
              .
            </p>
            <Link
              to="/"
              className="inline-block bg-navy text-ivory px-8 py-3 text-xs tracking-widest uppercase hover:bg-navy/90 transition-all"
            >
              Return to Home
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
